import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { BreadcrumbsInterface } from 'common/types/entities/BreadcrumbsInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createBreadcrumbs(
  parentId: string,
  masterBlockId?: MasterBlockId,
) {
  return {
    ...generateBaseEntity(EntityTypeEnum.Breadcrumbs, parentId, masterBlockId),
    fontSize: 20,
    itemColor: 'rgba(124, 124, 124, 1)',
    lastItemColor: 'rgba(20, 45, 99, 1)',
    margin: {
      marginTop: 10,
      marginRight: 0,
      marginBottom: 10,
      marginLeft: 0,
    },
  }
}
